<template>
  <section class="agenda tuesday">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Thursday, May 1st
            </h1>
          </div>
          <button class="rotate-btn" v-bind:class="{ 'is-rotated': isRotated, 'iphone-btn': isIphone }"
          @click="seccionVisible = !seccionVisible" v-on:click="toggleRotation">
            <svg :class="{ 'iphone': isIphone }" width="14px" height="9px" viewBox="0 0 18 11">
              <path fill="#3AADCC" d="M9.1,7.8l6.6-6.6C15.8,1.1,16,1,16.1,0.9c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3
              s0.2,0.3,0.3,0.4C18,1.8,18,2,18,2.2s0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.4l-7.5,7.5C9.8,10.8,9.5,11,9.2,11
              c-0.4,0-0.7-0.1-0.9-0.4L0.8,3.1C0.7,3,0.6,2.8,0.5,2.7C0.3,2.5,0.2,2.4,0.2,2.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4
              S0.9,1.1,1,1c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0.1C2.3,1,2.4,1.1,2.5,1.2L9.1,7.8z"/>
            </svg>
          </button>
        </div>
        <hr class="date__line">
      </div>
      <transition name="fade">
        <div v-show="seccionVisible">
          <div class="cards__container">
            <div class="cards__single grayblue">
              <p class="cards__title">
                Doors Open
              </p>
              <div class="cards__description">
                <p>11:00 AM</p>
              </div>
            </div>
            <br class="line-brk">
            <div v-for="(speaker, index) in morningSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
            <div class="cards__single grayblue">
              <p class="cards__title">
                VIP Lunch
              </p>
              <div class="cards__description">
                <p>1:10 PM - 2:30 PM</p>
              </div>
            </div>
            <br class="line-brk">
            <div v-for="(speaker, index) in afternoonSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div class="cards__single cocktail">
              <p class="cards__title">
                Cocktail Hour
              </p>
              <div class="cards__description">
                <p>6:00 PM - 7:30 PM</p>
              </div>
            </div>
            <div class="cards__single dinner">
              <p class="cards__title">
                Whale Supper Club
              </p>
              <div class="cards__description">
                <p>7:30 PM - 9:30 PM</p>
              </div>
            </div>
            <div class="cards__single party">
              <p class="cards__title">
                DNA x Mario Nawfal's Uncensored - Legendary Afterparty 2.0<br>Powered by T-Rize
              </p>
              <div class="cards__description">
                <p>10:00 PM - 4:00 AM</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda.scss';
</style>

<script>
export default {
  name: 'Day One',
  data() {
    return {
      seccionVisible: true,
      isRotated: false,
      isIphone: false,
      morningSet: [
        { 
          logoClass: 'persist',
          name: 'Persist Ventures',
          title: 'Maker Lee',
          time: '12:00 PM - 12:10 PM',
          class: 'logo'
        },
        {
          logoClass: 'yield',
          name: 'Yield Nest',
          title: 'Roy Selbach, CEO',
          time: '12:10 PM - 12:20 PM',
          class: 'logo'
        },
        {
          logoClass: 'pact',
          name: 'Pact Swap',
          title: 'Toby Gilbert, CEO',
          time: '12:20 PM - 12:30 PM',
          class: 'logo'
        },
        {
          logoClass: 'estatex',
          name: 'EstateX',
          title: 'Bart de Bruijn, Founder',
          time: '12:30 PM - 12:40 PM',
          class: 'logo'
        },
        {
          logoClass: 'wirenetwork',
          name: 'Wire Network',
          title: 'Company Presentation',
          time: '12:40 PM - 12:50 PM',
          class: 'logo'
        },
        {
          logoClass: 'kredete',
          name: 'Kredete',
          title: 'Adeola Adedewe, Founder & CEO',
          time: '12:50 PM - 1:00 PM',
          class: 'logo'
        },
        {
          logoClass: 'wow',
          name: 'WOW!?',
          title: 'Rick Latona, Founder & CEO',
          time: '1:00 PM - 1:10 PM',
          class: 'logo'
        },
        {
          imgClass: 'yat',
          name: 'Future Unfolded: Yat Siu on Web3, Gaming, and Innovation',
          title: 'Yat Siu, Co-Founder & Executive Chairman<br>Animoca Brands',
          time: '1:15 PM - 1:45 PM',
          class: 'noheight special'
        },
      ],
      afternoonSet: [
        {
          name: 'The Intelligence Layer: Bittensor, Subnets & the Rise of Decentralized AI',
          title: 'Panel Moderator: Chris Miglino, DNA<br>Colin Gagich, Inference Labs<br>Mike Grantis, Contango<br>Ben James, 404',
          time: '2:30 PM - 3:00 PM',
          class: 'noheight panel'
        },
        {
          name: "The Future and Fusion of CEX's DEX's and AI",
          title: 'Panel Moderator: George Cao, AscendEX<br>Gracey Chen, Bitget<br>Ran Yi, Orderly<br>Nenter Chow, BitMart',
          time: '3:20 PM - 3:50 PM',
          class: 'noheight panel'
        },
        {
          imgClass: 'r-k',
          name: 'Fireside Chat',
          title: 'Dr. Raghavendra Hunasgi, Zeebu<br>Kamal Youssefi, The Hashgraph Association',
          time: '3:50 PM - 4:10 PM',
          class: 'noheight special'
        },
        {
          name: 'A Deep Dive into How Traditional Finance Players Are Navigating and Embracing Tokenization',
          title: 'Jay Madhu, Oxbridge / SurancePlus<br>Fahmi Syed, Input Output / Midnight<br>Jake O., BitGo',
          time: '4:10 PM - 4:30 PM',
          class: 'noheight panel'
        },
        {
          name: 'RWA Real Estate',
          title: 'Panel Moderator: Zak Taher, Multibank<br>Alex Davis, Mavryk Dynamics<br>Amer Jabr, MAG Lifestyle Development',
          time: '4:30 PM - 5:00 PM',
          class: 'noheight panel'
        },
        {
          imgClass: 'w-r',
          name: 'Fireside Chat: Brand Power in a Borderless World - How Binance Is Shaping the Global Narrative of Web3',
          title: 'Wahid Chammas, TyreGate Capital Holdings<br>Rachel Conlan, CMO Binance',
          time: '5:00 PM - 5:30 PM',
          class: 'noheight special'
        },
        {
          imgClass: 'm-b',
          name: 'Fireside Chat',
          title: 'Mario Nawfal, IBC Ventures<br>Brock Pierce, DNA',
          time: '5:30 PM - 6:00 PM',
          class: 'noheight special short-special'
        }
      ]
    }
  },
  methods: {
    toggleRotation() {
      this.isRotated = !this.isRotated;
    },
  },
  mounted() {
    this.isIphone = /iPhone/.test(navigator.userAgent);
  }
};
</script>
